export default __webpack_public_path__ + "static/media/piano.40efb249.png";